const INSIGHTS_DESIGN_ENABLED = false;

export function insightsDesignEnabled() {
  return INSIGHTS_DESIGN_ENABLED;
}

/** Joins Insights section band classes when design is enabled; keeps optional extra classes either way. */
export function insightsSectionClassName(sectionClass, additionalClasses = "") {
  const extra = additionalClasses.trim();
  if (!insightsDesignEnabled()) {
    return extra || undefined;
  }
  return [sectionClass, extra].filter(Boolean).join(" ");
}
